import { render } from "./AddSandboxUser.vue?vue&type=template&id=4903c741"
import script from "./AddSandboxUser.vue?vue&type=script&lang=js"
export * from "./AddSandboxUser.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sivasankarelango/Sivasankar/test-cx/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__